import { IconButton, Typography } from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';
import BackArrowIcon from '../svg/BackArrowIcon';
import palette from '../theme/palette';

export default function Header({ title, onBack, subTitle, noMargin = false }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', marginBottom: noMargin ? 0 : '20px' }}>
      <IconButton style={{ marginRight: 15 }} onClick={() => onBack()}>
        <BackArrowIcon />
      </IconButton>
      <div>
        <Typography variant="h4" textTransform="capitalize">
          {title}
        </Typography>
        {subTitle && (
          <Typography variant="subtitle2" style={{ color: palette.grey[500] }}>
            {subTitle}
          </Typography>
        )}
      </div>
    </div>
  );
}

Header.propTypes = {
  title: PropTypes.string,
  onBack: PropTypes.func,
  subTitle: PropTypes.string,
  noMargin: PropTypes.bool
};
